import { gql } from '@apollo/client';

export const GQL_UPDATE_CAMERA = gql`
  mutation UPDATE_CAMERA($input: UpdateCameraInput!) {
    updateCamera(input: $input)
  }
`;

export const GQL_RTSP_PUSH = gql`
  mutation RTSP_PUSH($rtspPushInput: RTSPPushInput!) {
    push(input: $rtspPushInput) {
      start
      camera
      container
      url
      mute
      acodec
      cmd
    }
  }
`;

export const GQL_CAMERA_TEST = gql`
  mutation CAMERA_TEST($cameraId: ID!) {
    cameraTest(cameraId: $cameraId)
  }
`;

export const GQL_CAMERA_RESET = gql`
  mutation CAMERA_RESET($cameraId: ID!) {
    cameraReset(cameraId: $cameraId)
  }
`;

export const GQL_RTSP_PUSH_STOP = gql`
  mutation RTSP_PUSH_STOP($cameraId: ID!, $pushId: ID!) {
    stop(cameraId: $cameraId, pushId: $pushId)
  }
`;
